export default __webpack_public_path__ + "static/media/36.dd104481.png";